<template>
  <Layout>
    <template v-slot:default>
      <q-page>
        <div class="centered-container fill-height q-px-xl q-pt-xl">
          <div class="col-12 text-center">
            <p class="text-flat q-mt-sm text-h4">
              {{ i18n.title }}
            </p>
          </div>

          <!-- No invitations -->
          <q-banner
            v-if="workspace_groups.length == 0"
            class="bg-pastel-blue q-px-md q-mt-lg"
            dense
            style="width: fit-content"
          >
            <template v-slot:avatar>
              <q-icon
                name="las la-info-circle"
                class=""
                size="sm"
              />
            </template>
            <div class="">
              {{ i18n.list_empty }}
            </div>
          </q-banner>

          <div
            v-for="(workspace_group) in workspace_groups"
            :key="workspace_group.id"
          >
            <!-- WorkspaceGroups -->
            <div class="col-12 q-mt-xl q-pt-xl">
              <span class="text-h6">{{ workspace_group.name }}</span>
            </div>

            <!-- Invitations -->
            <div class="row q-col-gutter-md q-mt-xs justify-start">
              <div
                v-for="(invitation) in workspace_group.invitations"
                :key="invitation.id"
                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 self-stretch"
              >
                <q-card class="text-center fit">
                  <q-card-section class="fit items-center">
                    <div class="column items-center justify-center self-center q-pa-sm fit text-center">
                      <q-item
                        class="text-left"
                        dense
                      >
                        <q-item-section avatar>
                          <q-avatar
                            square
                            color="white"
                            size="48px"
                          >
                            <Jdenticon
                              :text="invitation.workspace_id"
                              :size="48"
                            />
                          </q-avatar>
                        </q-item-section>

                        <q-item-section>
                          <q-item-label class="text-bold">
                            {{ invitation.workspace_name }}
                          </q-item-label>
                          <q-item-label
                            v-if="invitation.workspace_siren"
                            class="text-grey-6 text-caption"
                          >
                            SIREN: {{ invitation.workspace_siren }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>

                      <q-separator
                        inset
                        class="q-mx-xl"
                      />
                      <q-card-section class="text-center q-my-ms q-mx-sm">
                        <div class="text-caption">
                          <q-avatar
                            size="xs"
                            class="q-mr-sm"
                            style="margin-bottom: 2px"
                          >
                            <img
                              :src="invitation.user_avatar_url"
                              referrerpolicy="no-referrer"
                            >
                          </q-avatar>
                          {{ invitation.user_name }} {{ i18n.user_invite_you }}
                        </div>
                      </q-card-section>
                      <q-card-section class="text-center q-pa-sm q-mx-none full-width">
                        <!-- Accept and decline buttons -->
                        <div class="row no-wrap justify-around">
                          <q-btn
                            unelevated
                            rounded
                            color="negative"
                            size="sm"
                            class="text-white q-px-lg"
                            :label="i18n.action_decline"
                            no-caps
                            @click="invitations_respond(invitation.action_reject_link)"
                          />

                          <q-btn
                            color="positive"
                            class="q-px-lg"
                            size="sm"
                            unelevated
                            rounded
                            no-caps
                            :label="i18n.action_accept"
                            @click="invitations_respond(invitation.action_accept_link)"
                          />
                        </div>
                      </q-card-section>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </q-page>
    </template>
  </Layout>
</template>
<script>
import Layout from '@/layouts/wide.vue';
import Jdenticon from '@/shared/jdenticon.vue';

export default {
  components: {
    Jdenticon,
    Layout,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    workspace_groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    invitations_respond: function (link) {
      this.$inertia.put(
        link,
        {},
        {
          preserveState: true,
          preserveScroll: true,
          onStart: () => {
          },
          onSuccess: () => {
            this.$q.notify({
              message: this.$page.props.flash.success,
              type: "positive",
            });
          },
          onError: (errors) => {
            console.log(errors);
            this.$q.notify({
              message: this.$page.props.flash.alert,
              type: "negative",
            });
          },
          onFinish: () => {
          },
        }
      );
    },
  },
};
</script>
